import {
    Routes,
    Route
} from "react-router-dom";
import "./App.css";
import CheckIn from "./Components/CheckIn/checkin";
import Confirmation from "./Components/Confirmation/confirmation";

function App() {
    return (
        <div className="App">
            <div className="content-space">
                <Routes>
                    <Route path="/check-in" element={<CheckIn />} />
                    <Route path="/confirmation" element={<Confirmation />} />
                    <Route path="*" element={<CheckIn />} />
                </Routes>
            </div>
        </div>
    );
}

export default App;
